import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Locations Settings'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Locations Settings',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/settings/locations',
  component: RouteComponent,
  type: 'auth',
});
